var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.showStartUpPlan)?_c('div',{staticClass:"text-center",attrs:{"id":"loading"}},[_c('loading')],1):_vm._e(),_vm._v(" "),(!_vm.showStartUpPlan)?_c('b-row',{staticStyle:{"background":"#fffbfe"}},[_c('b-col',[_c('stepper',{attrs:{"steps":_vm.steps,"isSummaryPage":true}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }